var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-promo-group-carousel"},[_c('BleachSwiper',{ref:"swiper",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(item,index){return _c('BleachSwiperSlide',{key:index},[_c('NavigationMenuPromoGroupMobileItem',{attrs:{"content":item,"appearance":_vm.appearance}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }